import { FirebaseOptions, initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getPerformance } from 'firebase/performance';
import { getStorage } from 'firebase/storage';

/* eslint-disable no-console */
const originalConsoleError = console.error.bind(console);
console.error = (...arguments_: unknown[]) => {
  const first = arguments_[0];
  const errorOrString = first instanceof Error ? first.message : String(first ?? '');
  const text = typeof first === 'string' ? first : errorOrString;
  if (
    text.includes('performance/invalid') ||
    (text.includes('Performance') && text.includes('invalid'))
  ) {
    return;
  }
  originalConsoleError(...arguments_);
};

const firebaseConfig = JSON.parse(
  import.meta.env.VITE_FIREBASE_CONFIG as string,
) as FirebaseOptions;

const app = initializeApp(firebaseConfig);
export const database = getFirestore(app);
export const storage = getStorage(app);
export const performance = getPerformance(app);

if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    const message = event.message ?? (event.error as Error)?.message ?? '';
    const code = (event.error as { code?: string })?.code;
    if (
      code === 'performance/invalid' ||
      message.includes('performance/invalid') ||
      (message.includes('Performance') && message.includes('invalid'))
    ) {
      event.preventDefault();
      event.stopPropagation();
      return true;
    }
    return false;
  });
}

export default app;
